// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87f0c48d","455":"909aae11","977":"7519ba64"}[chunkId] + ".chunk.js";
};